import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import {
  NOTIFICATION_LIST,
  NOTIFICATION_UNREAD_COUNT,
  NOTIFICATION_MARK_READ,
  NOTIFICATION_MARK_UNREAD,
  NOTIFICATION_DELETE,
  NOTIFICATION_MY_LIST,
  NOTIFICATION_MY_UNREAD_COUNT,
  NOTIFICATION_MY_MARK_READ,
  NOTIFICATION_MY_MARK_UNREAD,
  NOTIFICATION_MY_DELETE,
} from "../actions/notification.actions.types";

const call = Effects.call;

function* getNotificationList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "notification",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getUnreadCount({ payload: { callback } = {} }) {
  const payload = {
    method: "get",
    url: "notification/unread-count",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* markRead({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: "notification/mark-read",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* markUnread({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: "notification/mark-unread",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* deleteNotifications({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "delete",
    url: "notification",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getMyNotificationList({ payload: { data, callback } }) {
  const payload = { method: "get", url: "notification/my", params: data };
  const { error, result } = yield call(httpClient, { payload, isLoader: false, authorization: true });
  if (error) { if (callback) callback({ success: false, data: null }); }
  else { if (callback) callback({ success: true, data: result.data }); }
}

function* getMyUnreadCount({ payload: { callback } = {} }) {
  const payload = { method: "get", url: "notification/my/unread-count" };
  const { error, result } = yield call(httpClient, { payload, isLoader: false, authorization: true });
  if (error) { if (callback) callback({ success: false, data: null }); }
  else { if (callback) callback({ success: true, data: result.data }); }
}

function* myMarkRead({ payload: { data, callback } }) {
  const payload = { data, method: "put", url: "notification/my/mark-read" };
  const { error, result } = yield call(httpClient, { payload, isLoader: false, authorization: true });
  if (error) { if (callback) callback({ success: false }); }
  else { if (callback) callback({ success: true, data: result.data }); }
}

function* myMarkUnread({ payload: { data, callback } }) {
  const payload = { data, method: "put", url: "notification/my/mark-unread" };
  const { error, result } = yield call(httpClient, { payload, isLoader: false, authorization: true });
  if (error) { if (callback) callback({ success: false }); }
  else { if (callback) callback({ success: true, data: result.data }); }
}

function* myDeleteNotifications({ payload: { data, callback } }) {
  const payload = { data, method: "delete", url: "notification/my" };
  const { error, result } = yield call(httpClient, { payload, isLoader: false, authorization: true });
  if (error) { if (callback) callback({ success: false }); }
  else { if (callback) callback({ success: true, data: result.data }); }
}

function* Notification() {
  yield all([
    takeLatest(NOTIFICATION_LIST, getNotificationList),
    takeLatest(NOTIFICATION_UNREAD_COUNT, getUnreadCount),
    takeLatest(NOTIFICATION_MARK_READ, markRead),
    takeLatest(NOTIFICATION_MARK_UNREAD, markUnread),
    takeLatest(NOTIFICATION_DELETE, deleteNotifications),
    takeLatest(NOTIFICATION_MY_LIST, getMyNotificationList),
    takeLatest(NOTIFICATION_MY_UNREAD_COUNT, getMyUnreadCount),
    takeLatest(NOTIFICATION_MY_MARK_READ, myMarkRead),
    takeLatest(NOTIFICATION_MY_MARK_UNREAD, myMarkUnread),
    takeLatest(NOTIFICATION_MY_DELETE, myDeleteNotifications),
  ]);
}

export default Notification;
